var read_cookie = function (k, r) { return (r = RegExp("(^|; )" + encodeURIComponent(k) + "=([^;]*)").exec(document.cookie)) ? r[2] : null; }
var getHashParams = function () {
    var hashs = location.hash.split("?");
    var hash = {
        tab: hashs[0] || ('#'+ location.searchParam['tab'])//.split("&")
    };
    var arr = (hashs[1] || '').split("&");
    for (var i = 0; i < arr.length; i++) {
        var chunk = arr[i];
        var a = chunk.split("=");
        if (a[0] !== "") hash[a[0]] = a[1] || true;
    }
    return hash;
};
var appendHashParams = function (o) {
    var hash = getHashParams();
    $.extend(hash, o);
    var res = [];
    var tab = hash.tab;
    delete hash.tab;
    for (var key in hash) {
        if (hash.hasOwnProperty(key)) {
            if (hash[key] != null)
                res.push(key + "=" + hash[key]);
        }
    }
    return tab + (res.length === 0 ? '' : ('?' + res.join('&')));
};
// We use pushState if it's available so the page won't jump, otherwise a shim.
var changeTab = function (tab) {
    //changeHash(appendHashParams({ tab: '#' + tab }));
    //changeHash(appendHashParams({ tab: '' }));
    var hash =  $.extend({}, location.searchParam, { tab: tab });
    var res = [];
    for (var key in hash) {
        if (hash.hasOwnProperty(key)) {
            if (hash[key] != null)
                res.push(key + "=" + hash[key]);
        }
    }

    if (history && history.pushState) {
        debugger;
        history.pushState(null, null, res.length === 0 ? '' : ('?' + res.join('&')));
    }
};
var changeHash = function (hash) {
    if (history && history.pushState) {
        history.pushState(null, null, hash);
    } else {
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;
        window.location.hash = hash;
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
    }
}
// TODO: make attacheable event
window.addHashChangedEventListener = function (handler) {
    var hash = this.location.hash;
    setInterval(function () {
        if (this.location.hash === hash) return;
        hash = this.location.hash;
        //console.trace("Hash changed", hash);
        handler(hash.substring(1));
    }, 50);
};

(function () {
    var search = this.location.search;
    var handlers = [];
    window.addSearchChangedEventListener = function (handler) {
        handlers.push(handler);
    };
    setInterval(function () {
        if (this.location.search === search) return;
        search = this.location.search;
        //console.trace("Hash changed", search);
        handlers.forEach(function (el) {
            el(search.substring(1));
        });
    }, 50);
})();

var SearchParam = function (search) {
    location.searchParam = search.split('&').reduce(function (pair, value) {
        var v = value.split('=');
        pair[v[0]] = v[1];
        return pair;
    }, {});
};
SearchParam(this.location.search.substring(1));
window.addSearchChangedEventListener(SearchParam);